import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from '@mui/material';
import React, { FC, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { Controller } from 'react-hook-form';

import { PaymentMethod } from '../../../../api/def_common_api';
import { useBasket } from '../../../../hooks/useBasket';

const ControlFields: FC = () => {
  const { getValues, control } = useFormContext();
  const { checkout } = useBasket();

  return (
    <FormControl>
      <Controller
        control={control}
        name="payment_method"
        render={({ field: { onChange, value } }) => (
          <RadioGroup
            value={value}
            onChange={onChange}
            defaultValue="payment_online"
          >
            {checkout.is_physical_person ? (
              <>
                {checkout.receiving_method === 'delivery' && (
                  <FormControlLabel
                    checked={value === PaymentMethod.PaymentOnline}
                    value="payment_online"
                    className={
                      value === PaymentMethod.PaymentOnline
                        ? 'Checkout_div_left_part3_pay_radio active payment_online'
                        : 'Checkout_div_left_part3_pay_radio '
                    }
                    control={
                      <Radio
                        sx={{
                          color: '#D7DDE9',
                        }}
                      />
                    }
                    label="Банковской картой на сайте"
                  />
                )}
                {checkout.receiving_method === 'self_delivery' && (
                  <>
                    {checkout.receiving_method === 'self_delivery' && (
                      <FormControlLabel
                        checked={value === PaymentMethod.PaymentOnline}
                        value="payment_online"
                        className={
                          value === PaymentMethod.PaymentOnline
                            ? 'Checkout_div_left_part3_pay_radio active payment_online'
                            : 'Checkout_div_left_part3_pay_radio'
                        }
                        control={
                          <Radio
                            sx={{
                              color: '#D7DDE9',
                            }}
                          />
                        }
                        label="Банковской картой на сайте"
                      />
                    )}

                    <FormControlLabel
                      checked={value === PaymentMethod.BankTransfer}
                      value="bank_transfer"
                      className={
                        value === PaymentMethod.BankTransfer
                          ? 'Checkout_div_left_part3_pay_radio active bank_transfer'
                          : 'Checkout_div_left_part3_pay_radio'
                      }
                      control={
                        <Radio
                          sx={{
                            color: '#D7DDE9',
                          }}
                        />
                      }
                      label="Банковской картой при получении товара"
                    />
                    <FormControlLabel
                      checked={value === PaymentMethod.PaymentOnDelivery}
                      value="payment_on_delivery"
                      className={
                        value === PaymentMethod.PaymentOnDelivery
                          ? 'Checkout_div_left_part3_pay_radio active payment_on_delivery'
                          : 'Checkout_div_left_part3_pay_radio'
                      }
                      control={
                        <Radio
                          sx={{
                            color: '#D7DDE9',
                          }}
                        />
                      }
                      label="Наличными при получении товара"
                    />
                  </>
                )}
              </>
            ) : (
              <>
                <FormControlLabel
                  checked={value === PaymentMethod.PaymentOnline}
                  value="payment_online"
                  className={
                    value === PaymentMethod.PaymentOnline
                      ? 'Checkout_div_left_part3_pay_radio active payment_online'
                      : 'Checkout_div_left_part3_pay_radio'
                  }
                  control={
                    <Radio
                      sx={{
                        color: '#D7DDE9',
                      }}
                    />
                  }
                  label="Банковской картой на сайте"
                />

                <FormControlLabel
                  checked={value === PaymentMethod.BankTransfer}
                  value="bank_transfer"
                  className={
                    value === PaymentMethod.BankTransfer
                      ? 'Checkout_div_left_part3_pay_radio active payment_online'
                      : 'Checkout_div_left_part3_pay_radio'
                  }
                  control={
                    <Radio
                      sx={{
                        color: '#D7DDE9',
                      }}
                    />
                  }
                  label="Оплата на расчетный счет"
                />
              </>
            )}
          </RadioGroup>
        )}
      />
    </FormControl>
  );
};

export default ControlFields;
